import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 mb-6 transition-colors"
            >
              <i className="ri-arrow-left-line" />
              {t('back_to_home')}
            </button>

            <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-6">
              About CSSBuy Spreadsheet
            </h1>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-6">
              <p>
                CSSBuy Spreadsheet is an independent informational resource created to help buyers navigate the world of international purchasing through CSSBuy. We are not affiliated with CSSBuy officially, nor do we represent the company in any capacity. This website serves as a research and comparison tool for buyers who want to make informed decisions before making purchases.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">
                Our Mission
              </h2>
              <p>
                Our mission is to provide organized, up-to-date, and trustworthy information about products, sellers, shipping costs, and buying guides. We believe that informed buyers make better purchasing decisions, which leads to better experiences and fewer problems. By organizing product information into structured categories and providing comprehensive guides, we aim to save you time and reduce the risks associated with international buying.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">
                What We Offer
              </h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>Organized product categories with direct links to the main website</li>
                <li>Shipping cost guides and calculators for different countries</li>
                <li>Quality control (QC) guides to help you verify products before shipping</li>
                <li>Safety guides to help you avoid scams and common problems</li>
                <li>Comparison information for different buying platforms</li>
                <li>Updated information about coupons, discounts, and promotions</li>
              </ul>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">
                Languages and Regions
              </h2>
              <p>
                This website is available in three languages: Brazilian Portuguese (PT-BR), English, and German. Our primary audience is in Brazil, but we welcome visitors from all countries. We provide shipping information for Brazil, Germany, the UK, France, Spain, Italy, and other European destinations.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">
                Disclaimer
              </h2>
              <p>
                This is an independent website and is not the official CSSBuy website. All external links lead to the main website (kaspreadsheet.com). We do not sell products, process payments, or handle shipping directly. We provide information only. Always verify information on the official platform before making purchasing decisions.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-background-200">
              <div className="bg-primary-50 rounded-xl p-6 md:p-8 text-center">
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                  {t('final_cta')}
                </h3>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap"
                >
                  <i className="ri-external-link-line" />
                  {t('explore_spreadsheet')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}